(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Forms, 'DisableSubmitButtonWhenDropzoneUploadingCoordinator')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * Sets up and coordinates when submit button is to be disabled during Dropzone file uploading.
         *
         * @param {object} parameters
         * @param {Dropzone options object} parameters.dropzone
         * @param {string} parameters.submitButtonPath The path to the submit button.
         *
         * @memberOf Lfl.Forms
         * @lends Lfl.Forms.DisableSubmitButtonWhenDropzoneUploadingCoordinator
         * @constructor
         */
        Lfl.Forms.DisableSubmitButtonWhenDropzoneUploadingCoordinator = function (parameters) {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */
            var dropzone = parameters.dropzone;
            var submitButtonPath = parameters.submitButtonPath;
            var $submitButton;

            /*
            |-------------------------------------------------------------------------
            | State variables */
            var buttonDisabledExternally = false;
            var currentlyUploading = false;

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Sets up and enables the mechanism.
             */
            this.setUp = function () {
                $submitButton = $(submitButtonPath);

                dropzone.on('addedfile', function(){
                    currentlyUploading = true;
                    $submitButton.attr("disabled", true);
                });


                dropzone.on('queuecomplete', function(){
                    currentlyUploading = false;
                    if (true !== buttonDisabledExternally) {
                        $submitButton.attr("disabled", false);
                    }
                });
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function listenToExternalDisabledChanges() {
                // Source: https://stackoverflow.com/questions/31028169/listening-for-an-element-disable-event
                // Set up a new observer
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        // Check the modified attributeName is "disabled"
                        if (mutation.attributeName === "disabled") {
                            if ($submitButton.attr("disabled") === true) {
                                buttonDisabledExternally = true;
                            } else {
                                buttonDisabledExternally = false;
                                if (currentlyUploading) {
                                    // We have to force the button to be disabled until uploading is complete.
                                    $submitButton.attr("disabled", true);
                                }
                            }
                        }
                    });
                });
                // Configure to only listen to attribute changes
                var config = {attributes: true};
                // Start observing
                observer.observe(document.querySelector(submitButtonPath), config);
            }

        };
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
